import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import type { IPagamentoLoja } from "interfaces/loja";
import type { IPedidoDetalhe } from "interfaces/loja/pedido";
import {
  buildPedidoOperacionalInput,
  resolvePedidoOperacional,
} from "utils/pedidoOperacional";
import PedidoCabecalho from "./PedidoCabecalho";
import PedidoContinuarFluxo from "./PedidoContinuarFluxo";
import PedidoProximaEtapaCard from "./PedidoProximaEtapaCard";
import PedidoStatusOperacionalCard from "./PedidoStatusOperacionalCard";
import PedidoEtapasResumo from "./PedidoEtapasResumo";

type PedidoOperacionalHubProps = {
  detalhe: IPedidoDetalhe;
  pagamentos: IPagamentoLoja[];
};

export default function PedidoOperacionalHub({
  detalhe,
  pagamentos,
}: PedidoOperacionalHubProps) {
  const input = buildPedidoOperacionalInput(
    detalhe as unknown as Parameters<typeof buildPedidoOperacionalInput>[0],
    pagamentos
  );

  const o = resolvePedidoOperacional(input);

  return (
    <Stack sx={{ gap: 3 }}>
      <PedidoContinuarFluxo input={input} />

      <PedidoCabecalho
        numero={detalhe.numero}
        pedidoId={detalhe.id}
        status={detalhe.status}
        tipoEntrega={o.tipoEntrega}
        total={detalhe.total}
        pagamentos={pagamentos}
        compradorNome={detalhe.compradorNome}
        criadoEm={detalhe.criadoEm ?? detalhe.createAt}
      />

      <Grid container spacing={2} sx={{ width: "100%" }}>
        <Grid item xs={12} md={6}>
          <PedidoProximaEtapaCard input={input} />
        </Grid>
        <Grid item xs={12} md={6}>
          <PedidoStatusOperacionalCard input={input} />
        </Grid>
        <Grid item xs={12}>
          <PedidoEtapasResumo
            input={input}
            pagamentos={pagamentos}
            pedidoId={detalhe.id}
          />
        </Grid>
      </Grid>
    </Stack>
  );
}
